var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-container",class:{show: _vm.isShow},style:({'--timeAnimation': `${_vm.timeAnimation}s`})},[_c('icon',{staticClass:"icon animation",attrs:{"name":"mouse","color":"var(--light)","size":32}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }